export function getTournamentStatusName(key) {
  const status = {
    1: 'En cours de création ',
    2: 'Live',
    3: 'Terminé',
    4: 'Annulé',
  };

  return status[key];
}



// WEBPACK FOOTER //
// ./src/helpers/tournament.js